import React, { useEffect, useState } from "react";
import { Typography } from "antd";

import KSearchBar from "../../../../components/input/searchbar";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import {
  fetchOrFilterTransactionsAsync,
  setFetchTrx,
  setTrxSearchTerms,
  transactionsState,
} from "../../../../store/slices/transactions/transSlice";

const Header = ({ onFilter }) => {
  const trxSearchTerms = useSelector(transactionsState.trxSearchTerms);
  const dispatch = useDispatch();
  const [searchTerms, setSearchTerms] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1100);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1100);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSearchInput = (key, value) => {
    setSearchTerms({ ...searchTerms, [key]: value });
  };

  const handleFetchOrExport = (isExport = false) => {
    const hasFilters = Object.values(searchTerms).some((v) => v);

    const payload = {
      page: isExport ? 1 : parseInt(searchParams.get("page") || "1", 10),
      per_page: 25,
      ...searchTerms,

      ...(isExport && { export: true }), // ✅ Add export flag only when exporting
    };

    if (!isExport && !hasFilters) return; // prevent empty filter clicks

    if (!isExport) onFilter(true);

    dispatch(fetchOrFilterTransactionsAsync(payload));

    if (!isExport) {
      dispatch(setTrxSearchTerms(payload));
      setSearchParams(payload);
      dispatch(setFetchTrx(false));
    }
  };

  return (
    <div
      style={{
        background: "#fff",
        padding: "10px",
        borderBottom: "2px solid #E4E7EC",
      }}
    >
      <div
        style={{
          display: "flex",

          flexDirection: isMobile ? "column" : "row",
          justifyContent: isMobile ? "left" : "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography className=" fw-500 fz-24 tprimary">
            Transactions
          </Typography>
          <Typography className=" fw-400 fz-14 tsecondary">
            Showing results for terminal transactions.
          </Typography>
        </div>

        <div
          style={{
            display: "flex",
            gap: "8px",

            marginLeft: isMobile ? "-10px" : "0px",
            marginTop: isMobile ? "5px" : "0px",
            justifyContent: isMobile ? "left" : "center",
            alignItems: isMobile ? "left" : "center",
          }}
        >
          <div style={{ display: "flex", gap: "8px" }}>
            <KSearchBar
              placeholder="Search here"
              suffix={
                <SearchOutlined
                  onClick={() => handleFetchOrExport(false)}
                  style={{ cursor: "pointer" }}
                />
              }
              onChange={(e) => handleSearchInput("search", e.target.value)}
              onClear={() => {
                const hasSearchTerms = Object.entries(trxSearchTerms).some(
                  ([_, value]) =>
                    value !== undefined && value !== null && value !== "",
                );
                setSearchTerms({});

                if (hasSearchTerms) {
                  dispatch(setTrxSearchTerms({}));
                  dispatch(fetchOrFilterTransactionsAsync({ page: 1 }));
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Header;
